import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../../../core/domain/Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {OfferModel} from './Offer.model';

@injectable()
export class OfferFactory
  implements BaseDomainFactory<OfferModel, OfferModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: OfferModel.Props): OfferModel {
    return this.modelsRegistry.put(new OfferModel(props));
  }
}
